export default __webpack_public_path__ + "static/logo_stripes-a6c0a99dd3bda27d7d5b13173b9663fd.png";